import { z } from "zod";

/**
 * Response of `POST organization/:id/normalized-name` — the company name as a person would write
 * it in an email. Empty only when the organization has no name at all, so consumers still fall
 * back to `name` (PREC-2748, PREC-3923).
 */
export const OrganizationNormalizedNameSchema = z.object({
	nameNormalized: z.string(),
});

export type OrganizationNormalizedName = z.infer<typeof OrganizationNormalizedNameSchema>;
